











































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import stripJsonComments from 'strip-json-comments';
import PrismEditor from 'vue-prism-editor';

import {ILoraForwarderUdpService} from '@/services/lora/forwarder/ILoraForwarderUdp.service';
import {Notify} from '@/utils/Notify';

enum ConfigTabs {
  Local,
  Global,
}

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {PrismEditor},
})
export default class LoraForwarderConfigFileEditor extends Mixins<BaseComponent>(BaseComponent) {

  @Prop()
  private loraForwarderGenericService!: ILoraForwarderUdpService;

  private configLocal: string = '';
  private configGlobal: string = '';

  private saving = false;

  private ConfigTabs = ConfigTabs;
  private selectedTab: ConfigTabs = ConfigTabs.Local;

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.configLocal = await this.loraForwarderGenericService.getConfigFileLocal();
    this.configGlobal = await this.loraForwarderGenericService.getConfigFileGlobal();
  }

  private async reset() {
    await this.refresh();
  }

  private async save() {

    this.logger.info(`Saving config`);


    this.saving = true;

    try {

      if (this.selectedTab === ConfigTabs.Local) {

        try {
          JSON.parse(stripJsonComments(this.configLocal));
        } catch (error) {
          Notify.Error(this.logger, `The configuration file is no valid JSON`, error);
          return;
        }

        await this.loraForwarderGenericService.setConfigFileLocal(this.configLocal);
      } else {

        try {
          JSON.parse(stripJsonComments(this.configGlobal));
        } catch (error) {
          Notify.Error(this.logger, `The configuration file is no valid JSON`, error);
          return;
        }

        await this.loraForwarderGenericService.setConfigFileGlobal(this.configGlobal);
      }

      Notify.Info(this.logger, `Configuration saved, restart the forwarder to load the new configuration`);
    } catch (error) {
      Notify.Error(this.logger, `Could not save config file`, error);
    } finally {
      this.saving = false;
    }
  }
}
